require('../../../../shared/clipSearch/clipSearchService');
require('../../../../shared/singleClipService');
require('../../../../shared/clipSortService');
require('../../videoAnalysisTable/vAnalysisCustomHeaderService');

angular.module('app.admin.videoAnalysis.tabs.myClips.myClipsController', [
  'app.shared.clipSearchService',
  'app.shared.singleClipService',
  'app.admin.videoAnalysis.customHeaderService',
  'app.shared.clipSortService'
])
  .controller(
    'app.admin.videoAnalysis.tabs.myClips.myClipsController', [
      '$scope',
      'app.shared.clipSearchService',
      '$filter',
      '$stateParams',
      'app.shared.singleClipService',
      '$window',
      '$sce',
      '$state',
      'app.admin.videoAnalysis.customHeaderService',
      'app.shared.clipSortService',
      '$anchorScroll',
      function ($scope, clipSearchService, $filter, $stateParams, singleClipService, $window, $sce, $state, customHeaderService, clipSortService, $anchorScroll) {
        "use strict";

        $scope.clipResults = null;
        $scope.positions = ['LW', 'RW', 'C', 'LD', 'RD', 'G'];
        $scope.checkedClips = [];
        $scope.loadingClips = true;
        $scope.show_table_data = true;
        $scope.dashIcon = '<i class="fa fa-minus"><i>';
        $scope.customHeaders = customHeaderService;
        $scope.sorter = clipSortService;

        $scope.filterData = $scope.$parent.filterData ? $scope.$parent.filterData : {
          filters: {},
          labels: {},
          preset: null
        };

        $scope.emptyFilterTemplate = {
          message: '', //$sce.trustAsHtml('Use the <i class="fa fa-plus-square" style="margin-left: 5px; margin-right: 5px;"></i> icon on the right to filter category, opponent, date range, and/or player'),
          buttonTemplate: 'admin.videoAnalysis.myClips.emptyFilterButtons.html',
          buttonClass: 'clip-search-filter__buttons--no-margin clip-search-filter__buttons--align-right',
        };

        $scope.filterTemplate = {
          buttonTemplate: 'admin.videoAnalysis.myClips.filterButtons.html',
          buttonClass: 'clip-search-filter__buttons--no-margin clip-search-filter__buttons--row-layout',
          clear: () => {
            if (angular.isObject($scope.filterData.filters)) {
              for (let i in $scope.filterData.filters) {
                if ($scope.filterData.filters.hasOwnProperty(i)) {
                  delete $scope.filterData.filters[i];
                }
              }
            }

            if (angular.isObject($scope.filterData.preset)) {
              delete $scope.filterData.preset;
            }

            $scope.$parent.filterCleared = true;
          }
        };

        $scope.pager = {
          pageSize: 50,
          offset: 0,
          currentPage: 1,
          pageChanged: () => {
            $scope.pager.offset = ($scope.pager.currentPage - 1) * $scope.pager.pageSize;
            getClips();
            $anchorScroll('clipTableTop');
            /*if($stateParams.selected_clip) {
              $scope.toggleChecked(JSON.parse($stateParams.selected_clip.iclipid));
            }*/
          },
          show: () => {
            return $scope.clipResults && $scope.clipResults.count > $scope.pager.pageSize;
          },
          displayString: () => {
            let totalCount = $scope.clipResults ? $scope.clipResults.count : 0;
            let start = $scope.pager.offset + 1;
            let stop = $scope.pager.offset + $scope.pager.pageSize;

            if (stop > totalCount) {
              stop = totalCount;
            }

            return `Total: ${totalCount} Displaying: ${start} - ${stop}`;
          }
        };

        let tdStyleHelper = function(e, tr) { //fixes style issue of td cells not displaying correct while item is being dragged.
          let $originals = tr.children();
          let $helper = tr.clone();
          $helper.children().each(function(index)
          {
            $(this).width($originals.eq(index).width());
            $(this).height($originals.eq(index).height())
          });
          return $helper;
        };

        $scope.sortableOptions = {
          helper: tdStyleHelper,
          cancel: ".deselected_header"
        };

        let init = () => {
          if($stateParams.filter) {
            $scope.filterData.filters = JSON.parse($stateParams.filter);
          }

          $scope.defaultValue = angular.equals($scope.filterData.filters, {seasons:[28]})
                                || angular.equals($scope.filterData.filters, {end_date:null,seasons:[28],start_date:null});

          $scope.customHeaders.assignSelectedHeaders();
        };

        let getClips = () => {
          if (!angular.isObject($scope.filterData.filters)) {
            $scope.filterData.filters = {};
          }

          let filters = angular.copy($scope.filterData.filters);
          filters.offset = $scope.pager.offset;
          filters.limit = $scope.pager.pageSize;

          if (angular.isObject($state.current.filterOverride)) {
            for (let i in $state.current.filterOverride) {
              if ($state.current.filterOverride.hasOwnProperty(i)) {
                filters[i] = $state.current.filterOverride[i];
              }
            }
          }
          //console.log(filters);

          return clipSearchService.retrieve(filters)
            .then(
              response => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                } else {
                  $scope.clipResults = data;
                  $scope.filterData.labels = $scope.clipResults.filter_data.labels;

                  $scope.sortClips();

                  if(angular.isDefined($state.current.filterOverride) && $state.current.filterOverride['starred']) {
                    delete $scope.filterData.labels['starred-1'];
                  }

                  $scope.checkedClips = [];
                }

                $scope.loadingClips = false;
              }
            );
        };

        $scope.sortClips = (header) => {
          if(angular.isDefined(header)) {
            $scope.sorter.set_sort_type(header);
          }

          if($scope.clipResults && $scope.clipResults.clips.length > 0) {
            $scope.clipResults.clips = $scope.sorter.sort_clips($scope.clipResults.clips);
          }
        };

        $scope.getClipDatum = (clip_datum, clip) => {
          switch (clip_datum) {
            case 'clip_name':
              return clip.strclipname;

            case 'game_date':
              return $filter('date')(clip.game.dtegametimefixed, 'MMM. dd, yyyy');

            case 'matchup':
              return clip.game.league.strleaguenickname
                +': '+clip.game.awayteam.abbrev
                +' @ '+clip.game.hometeam.abbrev;

            case 'category':
              return clip.clip_category.strclipcategory;

            case 'subcategory':
              return clip.clip_subcategory;

            case 'clip_time':
              return $filter('left_pad')(clip.startClockTime.hour, 2)
                + ':' + $filter('left_pad')(clip.startClockTime.minute, 2)
                + ':' + $filter('left_pad')(clip.startClockTime.second, 2);

            case 'duration':
              return $filter('left_pad')(clip.clockTime.minute, 2)
                + ':' + $filter('left_pad')(clip.clockTime.second, 2);

            case 'clock_time':
              return clip.game_clocktime;

            case 'period':
              return clip.iperiod;
          }
        };

        $scope.getLineup = (clip, position) => {
          position = position.toLowerCase();
          return clip.lineup[position];
        };

        $scope.saveXeditable = (id, clip) => {
          let tempClip = clip;

          delete tempClip.is_collapsed;

          singleClipService.updateClip(id, tempClip)
            .then((response) => {
              let data = response.data;
              if (data.error) {
                $scope.error = data.error;
              }
            });
        };

        $scope.toggleForm = form => {
          if (form.$visible) {
            form.$submit();
          }
          else {
            form.$show();
          }
        };

        $scope.toggleStarred = clip => {
          singleClipService.toggleStarred(clip.iclipid)
            .then(
              response => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                }
                if (typeof data.status !== 'undefined') {
                  clip.is_starred = data.status;
                }
              }
            );
        };

        $scope.playClip = clip => {
          $window.open(
            '/popup/player/#/clip/' + clip.iclipid,
            `popupClip_${clip.iclipid}`,
            "height=700,width=640"
          );
        };

        $scope.syndicateClip = clip => {
          singleClipService.syndicate(clip.iclipid)
            .then((response) => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              } else {
                alert('Your clip is being prepared. We will email you the clip when it is ready.');
              }
            });
        };

        $scope.editClip = clip => {
          $state.go('app.play', {type: 'clip', id: clip.iclipid, clip_edit: true});
        };

        $scope.toggleChecked = clip_id => {
          let index = $scope.checkedClips.indexOf(clip_id);

          if (index > -1) {
            do {
              $scope.checkedClips.splice(index, 1);
              index = $scope.checkedClips.indexOf(clip_id);
            } while (index > -1);
          } else {
            $scope.checkedClips.push(clip_id);
          }
        };

        $scope.deleteClip = clip => {
          let confirmed = confirm(`Really delete ${clip.strclipname}?`);
          if (confirmed) {
            singleClipService.delete(clip.iclipid)
              .then(
                response => {
                  let data = response.data;
                  if (data.error) {
                    alert(data.error);
                  } else {
                    let clipIndex = $scope.clipResults.clips.indexOf(clip);
                    if (clipIndex > -1) {
                      $scope.clipResults.clips.splice($scope.clipResults.clips.indexOf(clip), 1);
                    }
                  }
                }
              );
          }
        };

        $scope.deleteCheckedClips = () => {
          let confirmed = confirm(`Really delete ${$scope.checkedClips.length} clips?`);
          if (confirmed) {
            singleClipService.bulkDelete($scope.checkedClips)
              .then(() => {
                getClips();
              });
          }
        };

        $scope.clearCheckedClips = () => {
          $scope.checkedClips = [];
        };

        $scope.showOrHideTableData = () => {
          $scope.show_table_data = !$scope.show_table_data;

          if(!$scope.show_table_data) {
            $scope.customHeaders.sortColumnHeaders();
          }
        };

        $scope.submitSelectedHeaders = () => {
          $scope.customHeaders.assignSelectedHeaders();
          $scope.customHeaders.calcEmptyWidth('#header-scroll-container');
          $scope.showOrHideTableData();
        };

        $scope.$watch(
          () => {
            return $scope.filterData.filters;
          },
          () => {
            getClips();
          },
          true
        );

        init();
      }
    ]
  );


// WEBPACK FOOTER //
// ./app.v2/components/admin/videoAnalysis/tabs/myClips/myClipsController.js